import { DocumentTypeModel } from "./DocumentType.model";
import { RolesArdModel } from "./RolesArd.model";

export class SignatureUsersModel {
    public DocumentNumber: string;
    public DocumentType: string;
    public Email: string;
    public CompanyName: string;
    public Charge: string;
    public DocumentName: string;
    public FirstName: string;
    public FirstSurname: string;
    public Id: number;
    public IdRequest: number;
    public MiddleName: string;
    public Phone: string;
    public Role: number;
    public SecondSurname: string;
    public Signature: string;
    public DocumentTypeNavigation: DocumentTypeModel;
    public RoleNavigation: RolesArdModel;
    public BirthDate: Date;
    public IdNationality: string;
    public NationalityName: string;
}

export class ChargeCatalog {
    lstChargesArd = [
        { Id: "1", Name: "Administrador", Label: "Request.Label.ChargeCatalog.Administrator" },
        { Id: "2", Name: "Administrativo", Label: "Request.Label.ChargeCatalog.Administrative" },
        { Id: "3", Name: "Agente", Label: "Request.Label.ChargeCatalog.Agent" },
        { Id: "4", Name: "Analista/especialista", Label: "Request.Label.ChargeCatalog.AnalystSpecialist" },
        { Id: "5", Name: "Director", Label: "Request.Label.ChargeCatalog.Director" },
        { Id: "6", Name: "Gerente", Label: "Request.Label.ChargeCatalog.Manager" },
        { Id: "7", Name: "Practicante", Label: "Request.Label.ChargeCatalog.Intern" },
        { Id: "8", Name: "Otro", Label: "Request.Label.ChargeCatalog.Other" },
        { Id: "9", Name: "Supervisor", Label: "Request.Label.ChargeCatalog.Supervisor" },
        { Id: "10", Name: "Vicepresidente", Label: "Request.Label.ChargeCatalog.Vicepresident" }
    ]
}

